import DiagnosticYield from './ui/diagnosticYield/diagnosticYield';

export default DiagnosticYield;
